
import { Actions } from "@/store/enums/StoreEnums";
import { defineComponent, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Loading from "@/components/Loading.vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { rutEsValido, formatRut, yupIsRut } from "@/core/validators/YupRut";
import { config } from "@/core/helpers/config";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default defineComponent({
    name: "Licitar",
    emits: ["cancelar", "guardarLicitante"],
    props: ["idLicitacion"],
    components: {
        Loading,
        Field,
        Form,
        ErrorMessage,
    },
    data() {
        return {
            carga: false,
            nombreProveedor: "",
            rut: "",
            telefono: "",
            correo: "",
            form: {
                nombreProveedor: "",
                rut: "",
                telefono: "",
                correo: "",
                idLicitacion: "",
            },
        };
    },
    setup(props, { emit }) {
        const store = useStore();
        const router = useRouter();
        var loading = ref(false);
        const mensajeInputnombreProveedor = ref(false);
        const mensajeInputrut = ref(false);
        const mensajeInputtelefono = ref(false);
        const mensajeInputcorreo = ref(false);

        const submitButton = ref<HTMLButtonElement | null>(null);
        Yup.addMethod(Yup.string, "yupIsRut", function (mensaje) {
            const { message } = mensaje;
            return this.test("yupIsRut", message, function (value) {
                const { path, createError } = this;
                const { some, more, args } = mensaje;
                // [value] - value of the property being tested
                // [path]  - property name,
                // ...
                return rutEsValido(value);
            });
        });

        const registration = Yup.object().shape({
            nombreProveedor: Yup.string()
                .required("El campo es requerido")
                .label("Nombre"),
            idLicitacion: Yup.string(),
            correo: Yup.string()
                .min(4, "Debe tener mas de 4 caracteres")
                .required("El campo es requerido")
                .email("No es válido")
                .label("Email"),
            telefono: Yup.string()
                // .min(9, "Debe tener 9 números como mínimo")
                // .max(11, "Debe tener 11 números como máximo")
                .matches(/^56\d{9}$/, 'El número de teléfono debe comenzar con 56 y seguir con 9 dígitos.')
                .required("El campo es requerido")
                .label("Teléfono"),
            rut: Yup.string()
                .test(
                    "yupIsRut",
                    "Rut ingresado no es valido",
                    function (value) {
                        return rutEsValido(value);
                    }
                )
                .required("El campo es requerido")
                .label("Rut"),
        });
        const cancelarSolicitud = () => {
            emit("cancelar", null);
        };

        const onSubmit = (values) => {
            loading.value = true;
            values.codigo = props.idLicitacion;

            // eslint-disable-next-line
            submitButton.value!.disabled = true;

            // Activate indicator
            submitButton.value?.setAttribute("data-kt-indicator", "on");
            // values.idLicitacion = props.idLicitacion
            console.log(values)
            store
                .dispatch(Actions.CREATE_LICITANTE, values)
                .then((data) => {
                    submitButton.value?.removeAttribute("data-kt-indicator");
                    submitButton.value!.disabled = false;

                    emit("guardarLicitante", data );

                })
                .catch(() => {
                    loading.value = false;
                    submitButton.value?.removeAttribute("data-kt-indicator");
                    submitButton.value!.disabled = false;
                    const [error] = Object.keys(store.getters.getErrors);
                    Swal.fire({
                        text: store.getters.getErrors[error],
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Intentar nuevamente",
                        customClass: {
                            confirmButton: "btn fw-bold btn-light-danger",
                        },
                    });
                });
           
        };

       
        return {
            cancelarSolicitud,
            // crearSolicitud,
            loading,
            mensajeInputnombreProveedor,
            mensajeInputrut,
            mensajeInputtelefono,
            mensajeInputcorreo,
            registration,
            submitButton,
            onSubmit,
        };
    },
    methods: {
        validarNumero(event) {
            const charCode = event.which || event.keyCode;

            if (
                (charCode >= 48 && charCode <= 57) || // Números del 0 al 9
                charCode === 8 || // Tecla de retroceso
                charCode === 9 || // Tecla de tabulación
                charCode === 37 || // Flecha izquierda
                charCode === 39 // Flecha derecha
            ) {
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        },
        formatRut() {
            var regex = /^[0-9.\-k]+$/;

            const isValid = regex.test(this.form.rut);

            if (isValid) {
                this.form.rut = formatRut(
                    this.form.rut.replace(/[^0-9.\-k]/g, "")
                );
            } else {
                this.form.rut = formatRut(this.form.rut.slice(0, -1));
            }
        },
    },
    mounted() {
        this.form.idLicitacion = this.$props.idLicitacion;
    },
});
